"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAXIMUM_TOKENS_PER_USER = exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    description: zod_1.z.string().min(1).max(255).nullable(),
});
exports.path = '/api-token-generate';
exports.MAXIMUM_TOKENS_PER_USER = 5;
//# sourceMappingURL=index.js.map